import { PortableText } from "@portabletext/react"
import { GatsbyImage } from "gatsby-plugin-image"
import { classNames } from "../../utils/helpers"
import Box from "../Box"
import CardContainer from "../CardContainer"
import Container from "../Container"
import Heading from "../Heading"
import SectionLink from "../SectionLink"
import { serializers } from "../Serializers"
import SwiperSlider from "../SwiperSlider"
import Text from "../Text"

const SectionFitIn = ({ section }: any) => {
  const { title, subTitle, listItems } = section

  return (
    <Container fullWidthOnMobile constrainedToBreakPoint>
      <Box className="max-w-xs mx-auto text-center scroll-pl-6 md:max-w-2xl lg:max-w-max">
        <Heading as="h2" className="text-blue-500 md:pb-10">
          {title}
        </Heading>
        <Text className="max-w-4xl">{subTitle}</Text>
      </Box>

      <Box className="w-screen lg:w-full lg:px-2">
        <SwiperSlider
          className="mt-6 lg:mt-8 lg:[&>.swiper-wrapper]:flex-wrap lg:[&>.swiper-wrapper]:gap-5 lg:[&>.swiper-wrapper]:justify-center lg:[&>.swiper-slide]:h-fit"
          childClassName="rounded-[20px] flex flex-col content-bottom overflow-hidden max-w-[75%] lg:max-w-[100%] lg:basis-[calc(50%-27px)] lg:last:basis-[calc(100%-23px)]"
          slidesPerView="auto"
          breakpoints={{
            1024: {
              slidesPerView: 3,
            },
          }}
          navigation={false}
        >
          {listItems.map((item: any, idx: any) => (
            <CardContainer
              key={idx}
              horizontalOnDesktop
              reverse
              narrow={idx === listItems.length - 1}
              forceHeight
              header={
                <Box className="relative w-full rounded-t-[20px] h-full lg:h-full">
                  <GatsbyImage
                    image={item.Image?.asset?.gatsbyImageData}
                    alt={item.Image?.asset?.altText || "fit in"}
                    objectFit="cover"
                    objectPosition={
                      idx === 0 ? "15%" : idx === 1 ? "70% center" : "top"
                    }
                    className="rounded-t-[20px] object-cover w-full h-full"
                  />

                  <Box className="z-10">
                    <DecorationSvg
                      color={
                        idx === 0
                          ? "#3E69B5"
                          : idx === 1
                          ? "#874C7F"
                          : "#7AC1BC"
                      }
                    />
                  </Box>
                </Box>
              }
              className={classNames(
                idx === 0
                  ? "ml-3 lg:ml-0"
                  : idx === listItems.length - 1
                  ? "mr-3 lg:mr-0"
                  : "",
                "h-full"
              )}
            >
              <Heading as="h4" className="text-blue-500">
                {item.title}
              </Heading>
              <Box>
                <PortableText
                  components={serializers}
                  value={item._rawContent}
                />
              </Box>
              <Box className="mt-auto align-baseline flex flex-col justify-between w-full">
                <SectionLink
                  link={item.linkPrimary}
                  className="text-white text-center align-baseline bg-orange-500 rounded-xl p-8 lg:w-auto lg:px-8 py-4 text-base font-bold"
                >
                  {item.linkPrimary?.title}
                </SectionLink>
              </Box>
            </CardContainer>
          ))}
        </SwiperSlider>
      </Box>
    </Container>
  )
}

const DecorationSvg = (props: { color: string | undefined }) => {
  return (
    <>
      <svg
        className="absolute lg:hidden top-0 left-0"
        width="49"
        height="102"
        viewBox="0 0 49 102"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.46357 101.271H-54.026C-63.4139 101.271 -70.4176 92.6286 -68.5301 83.4393L-51.2941 1.03441C-48.2641 -13.569 -35.3992 -24 -20.4978 -24H33.9918C43.3797 -24 50.3834 -15.3572 48.4958 -6.16795L31.2599 76.237C28.1802 90.8404 15.365 101.271 0.46357 101.271Z"
          fill={props.color}
        />
      </svg>
      <svg
        className="hidden lg:block absolute top-0 left-0"
        width="65"
        height="220"
        viewBox="0 0 65 220"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-31.2941 219.995H-139.417C-158.046 219.995 -171.943 202.845 -168.198 184.611L-133.996 21.0955C-127.984 -7.88193 -102.456 -28.5801 -72.8876 -28.5801H35.2356C53.864 -28.5801 67.7613 -11.4302 64.0159 6.80391L29.8147 170.319C23.7038 199.297 -1.72534 219.995 -31.2941 219.995Z"
          fill={props.color}
        />
      </svg>
    </>
  )
}

export default SectionFitIn
